export default __webpack_public_path__ + "static/media/LegislaturadelEdomex.6b4939bc.jpg";